import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http'
import { AppConfigService } from './app-config.service';
import { Observable } from 'rxjs/internal/Observable';
import { DeepDiveDetails } from '../models/DeepDiveDetails';
import { throwError, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IomService {

  public actionUrl: string;
  public IsAuthorized: boolean;
  public scopeStatus = new Subject<string>();
  // variables for edit Insight
  public versionID: string;
  public isLoadInsight: boolean;
  public rowRanking: number;
  public chartTitle: string;
  public observation: string;
  public graphData: any;
  public isOverAll: boolean;
  public categoryId: any;
  public subCategoryID: any;
  public categoryName: string;
  public ScopeCheckCounter: number = 0;
  public isactivedeepdive: boolean = true;
  public readonlyDD: boolean = false;
  public demoe2euid: boolean = false;
  public isPAMAuthenticatedEnabled: boolean;
  public isPAMAcc: boolean;
  public chunkSize: number = 120000000;
  public isManualUpload: boolean = false;
  public CategoryIDForRedirection: any;
  environment: any;
  public redirecttoStandalone: boolean = false;
  // End variables for edit Insight
  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
    this.environment = this.appConfigService.getEnvironment();
    this.actionUrl = this.environment.api.IOMAPIUrl;
  }
  setScopeStatus(value: string) {
    this.scopeStatus.next(value); //it is publishing this value to all the subscribers that have already subscribed to this message
  }
  public setPAMAuthentication(val: boolean) {
    this.isPAMAuthenticatedEnabled = val;
  }

  public isPAMAuthenticated(): boolean {
    return this.isPAMAuthenticatedEnabled;
  }
  public setPAMAccess(val: boolean) {
    this.isPAMAcc = val;
  }

  public isPAMAccess(): boolean {
    return this.isPAMAcc;
  }


  createProp<T>(clientName: String, clientGroup: String, market: String, projectName: String, marketUnit: String, opportunityId: String, OpportunityContractID: number, proposalId: String, userAccess: String, createdBy: String): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/CreateDIYOpportunity", { clientName, clientGroup, market, projectName, marketUnit, opportunityId, OpportunityContractID, proposalId, userAccess,createdBy });
  }
  CheckProp<T>(clientName: String, clientGroup: String, market: String, projectName: String, marketUnit: String, opportunityId: String, OpportunityContractID: number, proposalId: String, userAccess: String, createdBy: String): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/CheckDIYOpportunity", { clientName, clientGroup, market, projectName, marketUnit, opportunityId, OpportunityContractID, proposalId, userAccess,createdBy });
  }
  // getProp<T>(userName, e2euid): any {
  //   return this.http.get<T>(this.actionUrl + "/Ticket/GetUserProposalFilterDetails?userName=" + userName + "&e2euid=" + e2euid, {});
  // }

  getProp<T>(userName, e2euid): any {
    let frmData = new FormData();
    frmData.append("userName", userName);
    frmData.append("e2euid", e2euid);
    return this.http.post<T>(this.actionUrl + "/Ticket/GetUserProposalFilterDetails", frmData);
  }
  
  getEditDetails<T>(userName: String, e2eUId: String, userAccess: String, ContractId:String): any {
    return this.http.post<T>(this.actionUrl + "/Ticket/EditUserProposalFilterDetails?userName=" + userName + "&e2eUId=" + e2eUId + "&userAccess=" + userAccess+ "&ContractId=" + ContractId, {});
  }

  
  // getProp<T>(userName): any {
  //  let response : any
  //   this.http.get<T>(this.actionUrl + "/UserProposal/GetUserProposalFilterDetails?userName=" +userName, {})
  //   .map(res => { 
  //     return res
  //   }).subscribe(res => response = res)
  //   return response;
  // }

  //   async getProp<T>(userName) {
  //   const data = await this.http.get<T>(this.actionUrl + "/UserProposal/GetUserProposalFilterDetails?userName=" +userName).toPromise();
  //   return data;
  // }

  //  async getProp(userName) {
  //       let apiURL = this.actionUrl + "/UserProposal/GetUserProposalFilterDetails?userName=" +userName;
  //        await this.http.post(apiURL, {})
  //         .toPromise()
  //         .then(
  //           res => { // Success                
  //           sessionStorage.setItem("Proposaldetails", JSON.stringify(res));           
  //           },
  //         ); 
  // }
  TextAnaylsisWordCloud<T>(id: any, categoryId: any, subCategory: any, value: any, drill: any = "none"): Observable<T> {
    if (categoryId == undefined || categoryId == '') {
      categoryId = null;
    }
    if (subCategory == undefined || subCategory == '') {
      subCategory = null;
    }
    if (drill == "none") {
      drill = null
    }
    return this.http.get<T>(this.actionUrl + "/Ticket/GetWordCloudDetails?versionId=" + id + "&category=" + categoryId + "&subcategory=" + subCategory + "&wordlen=" + value + "&drill=" + drill);
  }

  TextAnaylsisTrend<T>(id: any, categoryId: any, subCategory: any): Observable<T> {
    if (categoryId == undefined || categoryId == '') {
      categoryId = null;
    }
    if (subCategory == undefined || subCategory == '') {
      subCategory = null;
    }
    return this.http.get<T>(this.actionUrl + "/Ticket/GetTrendDetails?versionId=" + id + "&category=" + categoryId + "&subcategory=" + subCategory);
  }
  CreateDeepdive<T>(UserOption, userType, domainOption, aoAnalytics, ioAnalytics, othersAnalytics, BAUploadedData, DisplayResolutionDesc, MandatoryExcelColumns, ExcelMappingFields, ProposalId, UserName, TopKeyWordsFilter_AO, TopKeyWordsFilter_IO, TopKeyWordsFilter_OTHERS, ActualExcelColumns, fileName, SheetName, ParentE2EUId, ParentDeliveryConstructUId, DeliveryConstructUId, Environment): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/HistoricalTicket/CreateDeepdive", { UserOption, userType, domainOption, aoAnalytics, ioAnalytics, othersAnalytics, BAUploadedData, DisplayResolutionDesc, MandatoryExcelColumns, ExcelMappingFields, ProposalId, UserName, TopKeyWordsFilter_AO, TopKeyWordsFilter_IO, TopKeyWordsFilter_OTHERS, ActualExcelColumns, fileName, SheetName, ParentE2EUId, ParentDeliveryConstructUId, DeliveryConstructUId, Environment});
  }
  CreateDeepdiveStandared<T>(UserOption, deepdiveConfig, classifiedBasedON, actualclassifiedBasedON, userType, BAUploadedData, DisplayResolutionDesc, MandatoryExcelColumns, ExcelMappingFields, ProposalId, UserName, fileName, ActualExcelColumns, SheetName, ParentE2EUId, ParentDeliveryConstructUId, DeliveryConstructUId, startDate, endDate, Language, Environment, enableDQT, IsLemmaEnabled, IsRestrictDDCreation): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/HistoricalTicket/CreateDeepdive", { UserOption, deepdiveConfig, classifiedBasedON,actualclassifiedBasedON, userType, BAUploadedData, DisplayResolutionDesc, MandatoryExcelColumns, ExcelMappingFields, ProposalId, UserName, fileName, ActualExcelColumns, SheetName, ParentE2EUId, ParentDeliveryConstructUId, DeliveryConstructUId, startDate, endDate, Language, Environment, enableDQT, IsLemmaEnabled, IsRestrictDDCreation });
  }
  UplodExcelFile<T>(frmdata): Observable<T> {

    return this.http.post<any>(this.actionUrl + "/Ticket/ValidateExcelFile", frmdata);
  }
  SaveDomainMappingData<T>(request): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/ConfigureDomainMapping", request);
  }
  getDeepDiveSummary<T>(request): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetTickets", request);
  }
  getDeepDiveStatus<T>(request): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetDDStatus", request);
  }
  archiveDeepDive<T>(versionId: string, isArchived: boolean): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/ShowHideDeepDive?mongoVersionId=" + versionId + "&isArchived=" + isArchived, {});
  }
  updateobs<T>(ObservationId: string, Observation: string, CategoryId: string, Level: number): Observable<T> {
    //return this.http.post<T>(this.actionUrl + "/DeepDiveSummary/UpdateObservation?observationId=" + observationId + "&observationText=" + observationText, {});
    return this.http.post<T>(this.actionUrl + "/Ticket/UpdateObservation", { ObservationId, Observation, CategoryId, Level });
  }
  updatecatobs<T>(categoryId: string, observationText: string): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/UpdateCategoryObservation?categoryId=" + categoryId + "&observationText=" + observationText, {});
  }
/**/
  GetPopupDetails<T>(request): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetPopupDetails", { request });
  }
  GetDqtFilterDetails<T>(versionId: string): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetDataQualityFilters?versionId=" + versionId, {});
  }
  GetDQTupdatedDetails<T>(request): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetDataQualityFilters", request);
  }

  ShowHideChart<T>(chartRequest): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/HideChart", chartRequest);
  }
  // getAMOTileProperties<T>(versionId: string, userType: number): Observable<T> {
  //   return this.http.get<T>(this.actionUrl + "/Ticket/GetAMOTiles?mongoVersionId=" + versionId + "&userType=" + userType, {});
  // }
  getAMOTileProperties<T>(versionId: string, Language: string, userType: number, request): Observable<T> {
    if (request == null)
      return this.http.post<T>(this.actionUrl + "/Ticket/GetAMOTiles?mongoVersionId=" + versionId + "&Language=" + Language +  "&userType=" + userType, []);
    else
      return this.http.post<T>(this.actionUrl + "/Ticket/GetAMOTiles?mongoVersionId=" + versionId + "&Language=" + Language +  "&userType=" + userType, request);
  }
  GetFilteredTicketCount<T>(versionId: string, Language: string, userType: number, request): Observable<T> {
    if (request == null)
      return this.http.post<T>(this.actionUrl + "/Ticket/GetFilteredTicketCount?versionId=" + versionId + "&Language=" + Language + "&userType=" + userType, []);
    else
      return this.http.post<T>(this.actionUrl + "/Ticket/GetFilteredTicketCount?versionId=" + versionId +  "&Language=" + Language + "&userType=" + userType, request);
  }
  LoadCategorySubcategoryCharts<T>(versionID: string, categoryID: string, isChartForCategory: boolean): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetSignificantChartsData", { versionID, categoryID, isChartForCategory });
  }

  getDeomgraphicsData(): Promise<Response> {
    return this.http.get('assets/data/scopedata.json').toPromise()
      .then(this.extractData)
      .catch(this.handleErrorPromise);
  }
  extractData(res: Response) {
    return res;
  }
  handleErrorPromise(error: Response | any) {
    console.error(error.message | error);
    return Promise.reject(error.message | error);
  }
  exportDeepdive(versionId: string, ddName: string): Observable<Blob> {
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    return this.http.get<Blob>(this.actionUrl + "/Ticket/ExportDeepdive?versionId=" + versionId + "&DDName=" + ddName, httpOptions);
  }
  errorHandler(error: HttpErrorResponse) {
    return throwError(error.message || "Server Error");
  }
  getSeverityHeatMapChart<T>(versionId: string): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetSeverityHeatMapChart?versionId=" + versionId, {});
  }
  getFDSDataForTextAnalytics<T>(e2euid): Observable<T> {
    return this.http.get<T>(this.actionUrl + "/HistoricalTicket/GetFDSFilterValues/?E2EUId=" + e2euid, {});
  }
  CreateDeepdiveFDS<T>(domainOption, useroption, aoAnalytics, ioAnalytics, othersAnalytics, DisplayResolutionDesc, DeliveryStructureAttribute, E2EUID, ProposalId, UserName, TopKeyWordsFilter_AO, TopKeyWordsFilter_IO, TopKeyWordsFilter_OTHERS): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/CreateDeepdiveFDS", { domainOption, useroption, aoAnalytics, ioAnalytics, othersAnalytics, DisplayResolutionDesc, DeliveryStructureAttribute, E2EUID, ProposalId, UserName, TopKeyWordsFilter_AO, TopKeyWordsFilter_IO, TopKeyWordsFilter_OTHERS }); //ActualExcelColumns, fileName 
  }
  CreateDeepdiveFDSStandard<T>(UserOption, deepdiveConfig, startDate, endDate, ticketType, DeliveryStructureAttribute, E2EUID, ProposalId, UserName): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/CreateDeepdiveFDS", { UserOption, deepdiveConfig, startDate, endDate, ticketType, DeliveryStructureAttribute, E2EUID, ProposalId, UserName });
  }
  GetCategoryandSubcategoryData<T>(VersionID ,Language, filtervalues , IsFilterModified): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetAutomationMitigation", { VersionID, Language, filtervalues,IsFilterModified});
  }
  InsertUpdateOpportunityData<T>(VersionId, CategoryId, SubCategoryId, CmbnCategoryId1, CmbnCategoryId2, CategoryName, IsDashboardEnabled, IncludedKeywords, ExcludedKeywords, New_categoryName, Flag, Insert_IncludedKeywordText, Insert_ExcludedKeywordText, IsSubCategory, isNameChangeOnly, CategoryType, IsKmeans, Language): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/AMInsertUpdateKeywords", { VersionId, CategoryId, SubCategoryId, CmbnCategoryId1, CmbnCategoryId2, CategoryName, IsDashboardEnabled, IncludedKeywords, ExcludedKeywords, New_categoryName, Flag, Insert_IncludedKeywordText, Insert_ExcludedKeywordText, IsSubCategory, isNameChangeOnly, CategoryType, IsKmeans, Language});
  }
  TriggerClassification<T>(VersionId, NoofCluster, ExitCondition, IsLemmaEnabled, FilteredLanguage): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetProcessStart", { VersionId, NoofCluster, ExitCondition, IsLemmaEnabled, FilteredLanguage });
  }
  UpdateDashboardEnabled<T>(VersionId, CategoryId, IsDashboardEnabled, CategoryName, TicketCount): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetDashboard", { VersionId, CategoryId, IsDashboardEnabled, CategoryName, TicketCount });
  }
  GetValueFromQueryParams(params: any, searchKey: string): string {
    let returnValue = undefined;
    if (Object.keys(params).length > 0) {
      Object.keys(params).forEach(key => {
        if (key.toLowerCase() === searchKey.toLowerCase()) {
          returnValue = params[key];
        }
      });
    }
    return returnValue;
  }
  getMySPClientDetails<T>(SolutionId, userId): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/MySolutionPlanner/CheckMySPAccess/?solutionId=" + SolutionId + "&userName=" + userId, {});
  }
  LoadAddEditCharts<T>(VersionId, RowRanking, CategoryId, SubCategoryId): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/LoadAddEditCharts", { VersionId, RowRanking, CategoryId, SubCategoryId });
  }
  PrevieworApplyCharts<T>(request): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/PrevieworApplyCharts", request);
  }
  GetFlowDetailsbyVersionId<T>(VersionId, UserDomainId): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetStrategybyVersionId", { VersionId, UserDomainId });
  }
  SaveCategoryClusterEdit<T>(CategoryId, Cluster, ExitCondition, VersionId, SelectedLanguage): Observable<T> {
    return this.http.get<T>(this.actionUrl + "/Ticket/SaveCategoryClusterEdit/?CategoryId=" + CategoryId + "&Cluster=" + Cluster + "&ExitCondition=" + ExitCondition + "&VersionId=" + VersionId + "&SelectedLanguage=" + SelectedLanguage);
  }
  SaveIgnoreKeywords<T>(VersionId, StopWords, Language): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/InsertandUpdateStopKeyWords", { VersionId, StopWords, Language });
  }
  LoadStandardCharts<T>(versionID: string, categoryID: string, subcategoryID: string, rowRanking: number,value, request, IsFilterModified) {
    if (request == null)
      return this.http.post<T>(this.actionUrl + "/Ticket/GetStandardCharts/?VersionId=" + versionID + "&CategoryId=" + categoryID + "&SubCategoryId=" + subcategoryID + "&RowRanking=" + rowRanking + "&value=" + value + "&IsFilterModified=" +IsFilterModified, []).pipe(take(1)).toPromise();
    else
      return this.http.post<T>(this.actionUrl + "/Ticket/GetStandardCharts/?VersionId=" + versionID + "&CategoryId=" + categoryID + "&SubCategoryId=" + subcategoryID + "&RowRanking=" + rowRanking + "&value=" + value + "&IsFilterModified=" +IsFilterModified, request).pipe(take(1)).toPromise();
  }
  LoadKeyInsightsCharts<T>(versionID: string, categoryID: number, subcategoryID: number, rowRanking: number, value, request, IsFilterModified): Observable<T> {
    if (request == null)
      return this.http.post<T>(this.actionUrl + "/Ticket/GetStandardCharts/?VersionId=" + versionID + "&CategoryId=" + categoryID + "&SubCategoryId=" + subcategoryID + "&RowRanking=" + rowRanking + "&value=" + value + "&IsFilterModified=" +IsFilterModified, []);
    else
      return this.http.post<T>(this.actionUrl + "/Ticket/GetStandardCharts/?VersionId=" + versionID + "&CategoryId=" + categoryID + "&SubCategoryId=" + subcategoryID + "&RowRanking=" + rowRanking + "&value=" + value + "&IsFilterModified=" +IsFilterModified, request);

  }
  // LoadStandardCharts<T>(versionID: string, categoryID: string, subcategoryID: string, rowRanking: number) {
  //   return this.http.get<T>(this.actionUrl + "/Ticket/GetStandardCharts/?VersionId=" + versionID + "&CategoryId=" + categoryID + "&SubCategoryId=" + subcategoryID + "&RowRanking=" + rowRanking).pipe(take(1)).toPromise();
  // }
  public GetPAMTokenFromAPI<T>(): Observable<any> {
    return this.http.get<any>(this.actionUrl + "/Auth/GetPAMAuthTokenFromCookie");
  }
  getPAMDataForTextAnalytics<T>(deliveryConstructUIds, isLoad): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/HistoricalTicket/GetPAMFilterValues", { deliveryConstructUIds, isLoad });
  }
  GetPAMFlowDetailsbyVersionId<T>(VersionId, UserDomainId): Observable<T> {
    return this.http.get<T>(this.actionUrl + "/Ticket/GetStrategybyVersionIdPAM?VersionId=" + VersionId + "&UserDomainId=" + UserDomainId);
  }
  CreateDeepdivePAMStandard<T>(UserOption, deepdiveConfig, startDate, endDate, ticketType, DeliveryStructureAttribute, E2EUID, ProposalId, UserName, ApplicationName): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/HistoricalTicket/UploadHistoricalTickets", { UserOption, deepdiveConfig, startDate, endDate, ticketType, DeliveryStructureAttribute, E2EUID, ProposalId, UserName, ApplicationName });
  }
  CreateDeepdiveFDSStandardATR<T>(UserOption, deepdiveConfig, startDate, endDate, ticketType, DeliveryStructureAttribute, E2EUID, ProposalId, UserName,classifiedBasedON, ApplicationName, Language, enableDQT, IsLemmaEnabled): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/HistoricalTicket/CreateDeepdiveFDS", { UserOption, deepdiveConfig, startDate, endDate, ticketType, DeliveryStructureAttribute, E2EUID, ProposalId, UserName,classifiedBasedON, ApplicationName, Language, enableDQT, IsLemmaEnabled });
  }
  CreateDeepdivePAMStandardATR<T>(UserOption, deepdiveConfig, startDate, endDate, ticketType, DeliveryStructureAttribute, E2EUID, ProposalId, UserName,classifiedBasedON, ApplicationName, Language, enableDQT, IsLemmaEnabled,IsRestrictDDCreation): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/HistoricalTicket/CreateSAASDeepdive", { UserOption, deepdiveConfig, startDate, endDate, ticketType, DeliveryStructureAttribute, E2EUID, ProposalId, UserName,classifiedBasedON, ApplicationName, Language, enableDQT, IsLemmaEnabled,IsRestrictDDCreation });
  }
  // CreateDeepdivePAMStandardATR<T>(UserOption, deepdiveConfig, startDate, endDate, ticketType, DeliveryStructureAttribute, E2EUID, ProposalId, UserName, ApplicationName, Language): Observable<T> {
  //   return this.http.post<T>(this.actionUrl + "/HistoricalTicket/CreateSAASDeepdive", { UserOption, deepdiveConfig, startDate, endDate, ticketType, DeliveryStructureAttribute, E2EUID, ProposalId, UserName, ApplicationName, Language });
  // }
  // CreateDeepdivePAMStandardATR<T>(UserOption, deepdiveConfig, startDate, endDate, ticketType, DeliveryStructureAttribute, E2EUID, ProposalId, UserName, ApplicationName, Language): Observable<T> {
  //   return this.http.post<T>(this.actionUrl + "/HistoricalTicket/CreateSAASDeepdive", { UserOption, deepdiveConfig, startDate, endDate, ticketType, DeliveryStructureAttribute, E2EUID, ProposalId, UserName, ApplicationName, Language });
  // }
  CreateDeepdivePAM<T>(domainOption, UserOption, aoAnalytics, ioAnalytics, othersAnalytics, DisplayResolutionDesc, DeliveryStructureAttribute, E2EUID, ProposalId, UserName, TopKeyWordsFilter_AO, TopKeyWordsFilter_IO, TopKeyWordsFilter_OTHERS, ApplicationName): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/HistoricalTicket/CreateDeepdiveFDS", { domainOption, UserOption, aoAnalytics, ioAnalytics, othersAnalytics, DisplayResolutionDesc, DeliveryStructureAttribute, E2EUID, ProposalId, UserName, TopKeyWordsFilter_AO, TopKeyWordsFilter_IO, TopKeyWordsFilter_OTHERS, ApplicationName }); //ActualExcelColumns, fileName
  }
  CreateDeepdiveFDSATR<T>(domainOption, UserOption, aoAnalytics, ioAnalytics, othersAnalytics, DisplayResolutionDesc, DeliveryStructureAttribute, E2EUID, ProposalId, UserName, TopKeyWordsFilter_AO, TopKeyWordsFilter_IO, TopKeyWordsFilter_OTHERS, ApplicationName): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/HistoricalTicket/CreateDeepdiveFDS", { domainOption, UserOption, aoAnalytics, ioAnalytics, othersAnalytics, DisplayResolutionDesc, DeliveryStructureAttribute, E2EUID, ProposalId, UserName, TopKeyWordsFilter_AO, TopKeyWordsFilter_IO, TopKeyWordsFilter_OTHERS, ApplicationName}); //ActualExcelColumns, fileName
  }
  CreateDeepdivePAMATR<T>(domainOption, UserOption, aoAnalytics, ioAnalytics, othersAnalytics, DisplayResolutionDesc, DeliveryStructureAttribute, E2EUID, ProposalId, UserName, TopKeyWordsFilter_AO, TopKeyWordsFilter_IO, TopKeyWordsFilter_OTHERS, ApplicationName): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/HistoricalTicket/CreateSAASDeepdive", { domainOption, UserOption, aoAnalytics, ioAnalytics, othersAnalytics, DisplayResolutionDesc, DeliveryStructureAttribute, E2EUID, ProposalId, UserName, TopKeyWordsFilter_AO, TopKeyWordsFilter_IO, TopKeyWordsFilter_OTHERS, ApplicationName}); //ActualExcelColumns, fileName
  }
  getTopKeyWords<T>(UserName, SelectedDomain, UserOption, E2EUID, TopKeyWordsFilter: any, isSkipTopWords, DoTicketPull, MinStartDate, MaxEndDate, UserType, ExistingStopwords, ApplicationName, IsLemmaEnabled): Observable<T> {
    if (sessionStorage.getItem('Instance') != 'PAM')
      return this.http.post<T>(this.actionUrl + "/Ticket/GetTopKeyWords", { UserName, SelectedDomain, UserOption, E2EUID, TopKeyWordsFilter, DoTicketPull, MinStartDate, MaxEndDate, UserType, ExistingStopwords, ApplicationName, IsLemmaEnabled });
    else
      return this.http.post<T>(this.actionUrl + "/HistoricalTicket/GetTopKeyWordsSAAS", { UserName, SelectedDomain, UserOption, E2EUID, TopKeyWordsFilter, DoTicketPull, MinStartDate, MaxEndDate, UserType, ExistingStopwords, ApplicationName, IsLemmaEnabled });
  }
  getTopKeyWords_Standalone<T>(UserName, SelectedDomain, UserOption, E2EUID, TopKeyWordsFilter: any, isSkipTopWords, DoTicketPull, MinStartDate, MaxEndDate, UserType, BAUploadedData, MandatoryExcelColumns, ExcelMappingFields, ActualExcelColumns, fileName, SheetName, IsLemmaEnabled ): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/HistoricalTicket/GetTopKeyWordsStandalone", { UserName, SelectedDomain, UserOption, E2EUID, TopKeyWordsFilter, DoTicketPull, MinStartDate, MaxEndDate, UserType, BAUploadedData, MandatoryExcelColumns, ExcelMappingFields, ActualExcelColumns, fileName, SheetName, IsLemmaEnabled  });
  }
  GetQualifiedDescription<T>(UserName, SelectedDomain, UserOption, E2EUID, TopKeyWordsFilter: any, isSkipTopWords, DoTicketPull, MinStartDate, MaxEndDate, UserType, ExistingStopwords, ApplicationName, IsLemmaEnabled): Observable<T> {
    if (sessionStorage.getItem('Instance') != 'PAM')
      return this.http.post<T>(this.actionUrl + "/Ticket/GetQualifiedDescription", { UserName, SelectedDomain, UserOption, E2EUID, TopKeyWordsFilter, DoTicketPull, MinStartDate, MaxEndDate, UserType, ExistingStopwords, ApplicationName, IsLemmaEnabled });
    else
      return this.http.post<T>(this.actionUrl + "/HistoricalTicket/GetQualifiedDescriptionSAAS", { UserName, SelectedDomain, UserOption, E2EUID, TopKeyWordsFilter, DoTicketPull, MinStartDate, MaxEndDate, UserType, ExistingStopwords, ApplicationName, IsLemmaEnabled });
  }
  GetQualifiedDescriptionStandalone<T>(UserName, SelectedDomain, UserOption, E2EUID, TopKeyWordsFilter: any, isSkipTopWords, DoTicketPull, MinStartDate, MaxEndDate, UserType, BAUploadedData, MandatoryExcelColumns, ExcelMappingFields, ActualExcelColumns, fileName, SheetName, IsLemmaEnabled ): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/HistoricalTicket/GetQualifiedDescriptionStandalone", { UserName, SelectedDomain, UserOption, E2EUID, TopKeyWordsFilter, DoTicketPull, MinStartDate, MaxEndDate, UserType, BAUploadedData, MandatoryExcelColumns, ExcelMappingFields, ActualExcelColumns, fileName, SheetName, IsLemmaEnabled  });
  }
  getStopKeywords<T>(request): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetselfLearnedStopwords", request);
  }
  getStopKeywords_standalone<T>(StopKeywords, userType: number, proposalId: string, ticketType: string, Language: string,IsLemmaEnabled): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetselfLearnedStopwords", { StopKeywords, userType, proposalId, ticketType, Language, IsLemmaEnabled });
  }

  DeleteStagingTickets<T>(cloudId: string): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/HistoricalTicket/DeleteStagingTicketsByCloudId?cloudId=" + cloudId, {});
  }

  logOut() {
    this.http.post(this.environment.PAM_PreLogOutURL, null).subscribe(data => {
      window.location.href = encodeURI(this.environment.PAM_Logout_URL);
    }, error => {
     // console.log(error);
    })
  }
  uploadExcelDataByChunks<T>(frmdata): Observable<T>  {    
    return this.http.post<T>(this.actionUrl + "/Ticket/UploadChunkFile", frmdata);
     // .pipe(take(1)).toPromise();
  }
  DeleteExcelFile<T>(fileName) {
    return this.http.get<T>(this.actionUrl + "/Ticket/DeleteExcelFiles?fileName=" + fileName + "&isTriggeredByService=false").pipe(take(1)).toPromise();
  }
  GetSheetName<T>(frmdata): Observable<T> {
    return this.http.post<any>(this.actionUrl + "/Ticket/GetSheetName", frmdata);
    //return this.http.get<T>(this.actionUrl + "/Ticket/GetSheetName");
  }
  ReadExcelColumns<T>(sheetName, frmData): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/ReadExcelColumns?sheetName=" + sheetName, frmData, {});
  }
  GetMasterClientDetails<T>(clientId): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetMasterClientDetails?clientId=" + clientId, {});
  }
  GetLanguageList<T>(): Observable<T> {
    return this.http.get<T>(this.actionUrl + "/Ticket/GetLanguageOptions");
  }
  GetDataCompletenessByVersionId<T>(versionId): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/DataQuality/GetDataCompletenessByVersionId?versionId=" + versionId, {});
  }
  GetDQTScoreByVersionId<T>(versionId): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/DataQuality/GetDQTScoreByVersionId?versionId=" + versionId, {});
  }
  GetColumnRelevanceFields<T>(versionId,  IsMandate, DescriptionType, RowRanking, ChartId): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/DataQuality/GetColumnRelevanceFields", { versionId, IsMandate, DescriptionType, RowRanking, ChartId});
  }
  GetDuplicateAndSimilarFields<T>(versionId,  IsMandate, DescriptionType, RowRanking, ChartId): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/DataQuality/GetDuplicateAndSimilarFields", { versionId, IsMandate, DescriptionType, RowRanking, ChartId});
  }
  GetDataRedundancyByVersionId<T>(versionId): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/DataQuality/GetDataRedundancyByVersionId?versionId=" + versionId, {});
  }
  ProceedDQT<T>(versionId: string): Observable<T>{
    return this.http.post<T>(this.actionUrl + "/DataQuality/DQTProceed?versionId=" + versionId, {});
  }
  AbortDQT<T>(versionId: string): Observable<T>{
    return this.http.post<T>(this.actionUrl + "/DataQuality/AbortDQT?versionId=" + versionId, {});
  }

  /// DQT - Data Validaity Calls
  GetDataValidityByVersionId<T>(versionId): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/DataQuality/GetDataValidityByVersionId?versionId=" + versionId, {});
  }
  GetDataValidityDescriptionDetails<T>(versionId,  IsMandate, DescriptionType, RowRanking, ChartId) : Observable<T>{
    return this.http.post<T>(this.actionUrl + "/DataQuality/GetDataValidityDescriptionDetails",{versionId, IsMandate, DescriptionType, RowRanking, ChartId});
  }

  ///DQT - Data Clarity Calls
  GetDataClarityByVersionId<T>(versionId): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/DataQuality/GetDataClarityByVersionId?versionId=" + versionId, {});
  }

  GetDataClarityDescriptionDetails<T>(versionId,  IsMandate, DescriptionType, RowRanking, ChartId) : Observable<T>{
    return this.http.post<T>(this.actionUrl + "/DataQuality/GetDataClarityDescriptionDetails",{versionId, IsMandate, DescriptionType, RowRanking, ChartId});
  }

  GetLemmaKeywords<T>(VersionId, KeywordIncluded, KeywordExcluded, StopKeyWords,Language): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/GetLemmaKeywords", { VersionId, KeywordIncluded, KeywordExcluded, StopKeyWords,Language});
  }
  LiveCategorization<T>(VersionId,frmdata): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/HistoricalTicket/LiveCategorization/?versionId=" + VersionId, frmdata);
  }
  // getFDSDataForTextAnalytics<T>(e2euid): Observable<T> {
  //   return this.http.get<T>(this.actionUrl + "/HistoricalTicket/GetFDSFilterValues/?E2EUId=" + e2euid, {});
  // }
  RefreshFDSDeepdive<T>(VersionId): Observable<T> {
    return this.http.get<T>(this.actionUrl + "/HistoricalTicket/RefreshFDSDeepdive/?versionId=" + VersionId);
  }

  LiveCategorizationStandalone<T>(VersionId): Observable<T> {
    return this.http.get<T>(this.actionUrl + "/HistoricalTicket/LiveCategorizationStandalone/?versionId=" + VersionId);
  }
  FileReUpload<T>(VersionId,FileName): Observable<T> {
    return this.http.get<T>(this.actionUrl + "/HistoricalTicket/FileReupload/?versionId=" + VersionId + "&FileName=" + FileName);
  }
  CancelReUpload<T>(VersionId): Observable<T> {
    return this.http.get<T>(this.actionUrl + "/HistoricalTicket/CancelReUpload/?versionId=" + VersionId);
  }
  CheckDuplicateColName<T>(frmdata): Observable<T> {
    return this.http.post<T>(this.actionUrl + "/Ticket/CheckDuplicateColName", frmdata);
  }
}
